import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/courses/page.tsx");
